import palette from '../palette';

export default {
  root: {
    color: palette.common.black,
    fontSize: '1rem',
  },
};
